import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../api/axios";
import styles from "./Admin.module.css";

const STATUSES = ["", "processing", "confirmed", "shipped", "delivered", "cancelled"];
const STATUS_BADGE = {
  processing: "badge-amber", confirmed: "badge-purple",
  shipped: "badge-gray", delivered: "badge-green", cancelled: "badge-red",
};

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [updating, setUpdating] = useState(null);

  const fetchOrders = () => {
    const params = filter ? { status: filter } : {};
    api.get("/admin/orders", { params }).then(r => setOrders(r.data.orders)).finally(() => setLoading(false));
  };

  useEffect(fetchOrders, [filter]);

  const updateStatus = async (orderId, status) => {
    setUpdating(orderId);
    try {
      await api.put(`/orders/${orderId}/status`, { status });
      toast.success(`Order updated to "${status}"`);
      fetchOrders();
    } catch { toast.error("Update failed"); }
    finally { setUpdating(null); }
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Orders</h1>
        <div className={styles.filterTabs}>
          {STATUSES.map(s => (
            <button key={s || "all"} onClick={() => setFilter(s)}
              className={`${styles.filterTab} ${filter === s ? styles.filterActive : ""}`}>
              {s || "All"}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="loading-center"><div className="spinner" /></div>
      ) : (
        <div className={styles.section}>
          <div className={styles.mobileScroll}>
            <table className={styles.table}>
              <thead>
                <tr><th>Order</th><th>Customer</th><th>Total</th><th>Payment</th><th>Status</th><th>Update</th></tr>
              </thead>
              <tbody>
                {orders.map(order => (
                  <tr key={order._id}>
                    <td>
                      <Link to={`/order/${order._id}`} className={styles.orderLink}>
                        #{order._id.slice(-6).toUpperCase()}
                      </Link>
                      <div className={styles.orderDate}>{new Date(order.createdAt).toLocaleDateString()}</div>
                    </td>
                    <td>
                      <div className={styles.productCellName}>{order.user?.name}</div>
                      <div className={styles.productCellBrand}>{order.user?.email}</div>
                    </td>
                    <td className={styles.priceCell}>₹{order.totalPrice?.toLocaleString()}</td>
                    <td>
                      <span className={`badge ${order.paymentInfo?.status === "paid" ? "badge-green" : "badge-amber"}`}>
                        {order.paymentInfo?.status}
                      </span>
                    </td>
                    <td>
                      <span className={`badge ${STATUS_BADGE[order.orderStatus] || "badge-gray"}`}>
                        {order.orderStatus}
                      </span>
                    </td>
                    <td>
                      {order.orderStatus !== "delivered" && order.orderStatus !== "cancelled" && (
                        <select className={styles.statusSelect} defaultValue=""
                          onChange={e => e.target.value && updateStatus(order._id, e.target.value)}
                          disabled={updating === order._id}>
                          <option value="">Change...</option>
                          {["confirmed", "shipped", "delivered", "cancelled"]
                            .filter(s => s !== order.orderStatus)
                            .map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {orders.length === 0 && <div className="empty-state"><h3>No orders found</h3></div>}
        </div>
      )}
    </div>
  );
}
